
export default function Unauthorized(){
  return <div className="mgt40 text-center fts-28">Token已过期/无效，请重新登录</div>
}